import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { setUsersCart, setVisitorCart } from '../redux/userSlice';

interface VariantValue {
	text: string;
	associatedVariant?: string;
	quantity: number;
	price: string;
	image: string;
}

export const useVariantCombination = (
	product: any,
	checkVariantCombinationIsAvailable: (isAvailable: boolean) => void,
	isGetCombinationOnly = false
) => {
	const dispatch = useAppDispatch();
	const { visitorCartStore } = useAppSelector(state => state.user);
	const { isUserLoggedIn } = useAppSelector(state => state.auth);
	const cart = useAppSelector(state => state.user.cart);
	const usersCart = isUserLoggedIn ? cart : visitorCartStore || [];

	const variantCombination = (): VariantValue | undefined => {
		const variantWithQuantity = Object.values(
			product?.productId?.option?.variatorValues?.[0]?.variatorValues ||
				{}
		)?.find((data: any) => data?.quantity >= 1) as VariantValue | undefined;
		return variantWithQuantity;
	};

	const [variantOneValue, setVariantOneValue] = useState<string>(
		product?.variantType || variantCombination()?.text || ''
	);

	const [resultForVariantCombination, setResultForVariantCombination] =
		useState<VariantValue | undefined>(undefined);

	const [variantTwoValue, setVariantTwoValue] = useState<string>(
		product?.associatedVariantType ||
			variantCombination()?.associatedVariant ||
			''
	);

	const [currentVariantQuantity, setCurrentVariantQuantity] = useState<
		number | undefined
	>(variantCombination()?.quantity);

	const [isVariantCombinationAvailable, setIsVariantCombinationAvailable] =
		useState(true);

	const updateItemPriceInState = (
		id: string,
		newPrice: string,
		variantType: string,
		associatedVariantType: string,
		image: string
	) => {
		// const itemToUpdateIndex = usersCart.findIndex(
		//   (item: any) => item.starterkitId?._id === id || item.productId?._id === id
		// );

		const itemToUpdateIndex = usersCart.findIndex((item: any) => {
			if (item?.productId?.option?.variatorValues?.length) {
				return (
					item.variantType === product.variantType &&
					item.associatedVariantType === product.associatedVariantType
				);
			} else {
				return (
					item.starterkitId?._id === id || item.productId?._id === id
				);
			}
		});

		console.log({ itemToUpdateIndex, usersCart, product });

		if (isUserLoggedIn) {
			dispatch(
				setUsersCart([
					...usersCart.slice(0, itemToUpdateIndex),
					{
						...usersCart[itemToUpdateIndex],
						price: +newPrice,
						image,
						variantType,
						associatedVariantType,
					},
					...usersCart.slice(itemToUpdateIndex + 1),
				])
			);
		} else {
			dispatch(
				setVisitorCart([
					...usersCart.slice(0, itemToUpdateIndex),
					{
						...usersCart[itemToUpdateIndex],
						price: +newPrice,
						variantType,
						image,
						associatedVariantType,
					},
					...usersCart.slice(itemToUpdateIndex + 1),
				])
			);
		}
	};

	useEffect(() => {
		if (variantOneValue || variantTwoValue) {
			const variators = product?.productId?.option?.variatorValues;
			console.log({ variantOneValue, variantTwoValue, variators });
			const resultForTwoVariantCombination = Object.values(
				variators?.[0]?.variatorValues || {}
			)?.find(
				(data: any) =>
					data?.text === variantOneValue &&
					data?.associatedVariant === variantTwoValue
			) as VariantValue | undefined;

			const resultForOneVariant = Object.values(
				variators?.[0]?.variatorValues || {}
			)?.find((data: any) => data?.text === variantOneValue) as
				| VariantValue
				| undefined;

			const findVariantCombination: VariantValue | undefined =
				variators?.length > 1
					? resultForTwoVariantCombination
					: resultForOneVariant;
			const isVariantCombinationAlreadyInCart = usersCart.find(
				(item: any) =>
					item.variantType === variantOneValue &&
					item.associatedVariantType === variantTwoValue
			);

			const isOnlyOneTypeVariantInCart = usersCart.find(
				(item: any) =>
					item.variantType === variantOneValue ||
					item.associatedVariantType === variantTwoValue
			);

			let itemAlreadyInCart = false;

			if (variators?.length > 1) {
				if (isVariantCombinationAlreadyInCart) {
					itemAlreadyInCart = true;
				}
			} else if (variators?.length === 1) {
				if (isOnlyOneTypeVariantInCart) {
					itemAlreadyInCart = true;
				}
			}

			if (itemAlreadyInCart && !isGetCombinationOnly) {
				// setIsVariantCombinationAvailable(false);
				// checkVariantCombinationIsAvailable(false);
				return;
			}

			console.log({ findVariantCombination: 'got here' });

			if (findVariantCombination) {
				const cartItemId = product.productId
					? product.productId?._id
					: product.starterkitId._id;

				if (findVariantCombination.quantity <= 0) {
					setIsVariantCombinationAvailable(false);
					checkVariantCombinationIsAvailable(false);
					return;
				}

				setResultForVariantCombination(findVariantCombination);

				if (!isGetCombinationOnly) {
					updateItemPriceInState(
						cartItemId,
						findVariantCombination.price,
						findVariantCombination.text,
						findVariantCombination.associatedVariant || '',
						findVariantCombination.image
					);
				}

				setCurrentVariantQuantity(+findVariantCombination.quantity);
				checkVariantCombinationIsAvailable(true);
				setIsVariantCombinationAvailable(true);
			} else {
				setIsVariantCombinationAvailable(false);
				checkVariantCombinationIsAvailable(false);
			}
		}
	}, [variantOneValue, variantTwoValue]);

	return {
		variantOneValue,
		variantTwoValue,
		resultForVariantCombination,
		setVariantOneValue,
		setVariantTwoValue,
		isVariantCombinationAvailable,
		currentVariantQuantity,
	};
};
